


















































import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'

import MessageEditorWithMedia from '../MessageEditorWithMedia/MessageEditorWithMedia.vue'
import { MessageSettingsData } from '../MessageEditorWithMedia/components/MessageSettings/types'
import { MessageEditorWithMediaProps } from '../MessageEditorWithMedia/mixins/mixins'
import { MessageEditorWithMediaData } from '../MessageEditorWithMedia/types'
import MiniPopup from '../MiniPopup/MiniPopup.vue'
import { MessageEditorWithMediaTab } from '../NewMessageEditors/types'
import CheckboxInput from '../Pi/fields/CheckboxInput/CheckboxInput.vue'
import Replicator from '../Replicator/Replicator.vue'
import { ComponentData } from '../Replicator/types'

@Component({
  components: {
    Replicator,
    CheckboxInput,
    MiniPopup,
  },
})
export default class MultiMessageEditorWithMedia extends Mixins<MessageEditorWithMediaProps>(MessageEditorWithMediaProps) {
  @VModel() model!: Array<MessageEditorWithMediaData>

  @Prop({ type: Boolean, default: false }) betaButtons!: boolean

  disabledByTariffTags = false

  isWarnPopupActive = false

  activeTabIndexValue = 0

  activeTabIndex(idx: number): void {
    this.activeTabIndexValue = idx
  }

  overwriteAttachments(): void {
    for (const modelElement of this.model) {
      modelElement.attachments = this.model[this.activeTabIndexValue].attachments
    }
    this.isWarnPopupActive = false
  }

  get computedModel(): Array<MessageEditorWithMediaData> {
    return this.model.map((message: MessageEditorWithMediaData): MessageEditorWithMediaData => ({ ...this.defaultDataStructure, ...message }))
  }

  // eslint-disable-next-line complexity,max-statements,sonarjs/cognitive-complexity
  set computedModel(value: Array<MessageEditorWithMediaData>) {
    if (value[this.activeTabIndexValue] && (this.pinMedia || this.pinButtons)) {
      const currentEditor = value[this.activeTabIndexValue]
      for (const editor of value) {
        if (currentEditor.buttons?.length || currentEditor.attachments?.length) {
          if (this.pinButtons) {
            editor.buttons = currentEditor.buttons
          }
          if (this.pinMedia) {
            editor.attachments = currentEditor.attachments
          }
        } else {
          if (this.pinButtons) {
            editor.buttons = value[0].buttons
          }
          if (this.pinMedia) {
            editor.attachments = value[0].attachments
          }
        }
      }
    }
    this.model = value
  }

  getTargetToUpload(): any {
    return {
      [this.targetToUpload().target]: this.targetToUpload().target_id,
    }
  }

  get defaultDataStructure(): MessageEditorWithMediaData {
    let defaultValue: MessageEditorWithMediaData = {
      text: '',
      attachments: [],
    }

    if (this.availableTabs.includes(MessageEditorWithMediaTab.SettingsTab)) {
      const defaultStructure: MessageSettingsData = {
        disable_link_preview: false,
        disable_notify: false,
        pin: false,
        remove_previous: false,
        remove_after: 0,
        send_after: 0,
        protect_content: false,
      }

      defaultValue = {
        ...defaultValue,
        ...this.settingsStructure ? this.settingsStructure : defaultStructure,
      }
    }

    if (this.availableButtonsTypes) {
      defaultValue = {
        ...defaultValue,
        buttons: [],
      }
    }
    return defaultValue
  }

  get componentData(): ComponentData {
    return {
      propsData: {
        availableButtonsTypes: this.availableButtonsTypes,
        availableTabs: this.availableTabs,
        buttonsRowsMax: this.buttonsRowsMax,
        buttonsInRowMax: this.buttonsInRowMax,
        counterMax: this.counterMax,
        disabled: this.disabled,
        placeholders: this.placeholders,
        inputConfigFn: this.inputConfigFn,
        hasMedia: this.hasMedia,
        pinMedia: this.pinMedia,
        pinButtons: this.pinButtons,
        overwriteButton: this.overwriteButton,
        baseApiUrl: this.baseApiUrl,
        targetToUpload: this.targetToUpload,
        filesToUploadLimit: this.filesToUploadLimit,
        editorMode: this.editorMode,
        tariffTags: this.tariffTags,
        removeButtonsCallback: this.removeButtonsCallback,
        allDocument: this.allDocument,
        disabledPanelElements: this.disabledPanelElements,
        options: this.options,
        buttonsHelpView: this.buttonsHelpView,
        settingsStructure: this.settingsStructure,
        topics: this.topics,
        blacklistMediaButtonTypes: this.blacklistMediaButtonTypes,
        betaButtons: this.betaButtons,
      },
      view: MessageEditorWithMedia,
    }
  }

  created(): void {
    this.disabledByTariffTags = Boolean(this.tariffTags)
  }
}
